module.exports = __webpack_public_path__ + "static/img/gaozhongyingyu.25f45eca.jpg";